import "./Symptoms.module.css";
import Header from "@/reusable_sections/Header";
import CareSeverityGuide from "./sections/CareSeverityGuide";
import TestingDayFlow from "./sections/TestingDayFlow";
import StartYourJourneyToClarity from "./sections/StartYourJourneyToClarity";
import Footer from "@/reusable_sections/Footer";
export default function SymptomsPage() {
  return <div>
      <Header />
      <CareSeverityGuide />
      <TestingDayFlow />
      <StartYourJourneyToClarity />
      <Footer />
    </div>;
}